import { render, staticRenderFns } from "./ConceptView.vue?vue&type=template&id=b72bfc0a&scoped=true&"
import script from "./ConceptView.vue?vue&type=script&lang=ts&"
export * from "./ConceptView.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptView.vue?vue&type=style&index=0&id=b72bfc0a&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72bfc0a",
  null
  
)

export default component.exports